import {KTSVG} from '_metronic/helpers'
import {
  getDiscountList,
  selectDiscountList,
  selectEditOrder,
  selectEditOrderId,
  selectEditOrderItems,
  selectOrderDeliveryMethod,
} from 'app/features/orders/redux/order/orderEditSlice'
import React, {useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import find from 'lodash/find'

import {simpleCurrency} from 'app/format/currency'
import clsx from 'clsx'
import {deliveryTypes} from 'app/constant'
import filter from 'lodash/filter'
import orderEditService from 'app/services/OrderEditService/OrderEditService'
import {discountValueType} from 'app/features/orders/models/DiscountCode'
import {Order} from 'app/features/orders/models/EditOrderState'

interface Props {
  onDiscount: (val: any) => void
  discount: Record<string, any>
  onIsValidating: (val: any) => void
  onError: (val: any) => void
  isPromoCode: boolean
}

export const PromoCodeSelection: React.FC<Props> = ({
  onDiscount,
  discount,
  onIsValidating,
  onError,
  isPromoCode,
}) => {
  const dispatch = useDispatch()
  const discountCodeList = useSelector<RootState, any[]>(selectDiscountList)
  const deliveryMethod = useSelector<RootState, string>(selectOrderDeliveryMethod)
  const orderItems = useSelector<RootState, any[]>(selectEditOrderItems)
  const orderEditId = useSelector<RootState, string>(selectEditOrderId)
  const order = useSelector<RootState, Order>(selectEditOrder)

  useEffect(() => {
    dispatch(getDiscountList())
  }, [dispatch])

  const discounts = useMemo(() => {
    if (deliveryMethod === deliveryTypes.pickup) {
      return filter(
        discountCodeList,
        ({discountRule}) =>
          discountRule.discountType !== 'SHIPPING' || discountRule.discountType !== 'FREE_SHIPPING'
      )
    }
    return discountCodeList
  }, [deliveryMethod, discountCodeList])

  const handlePromoCodeChange = async (e: any) => {
    try {
      onError('')
      const {value} = e.target
      const discount = find(discountCodeList, {id: value})
      if (discount) {
        onIsValidating(true)
        const model = {
          lineItems: orderItems,
          orderEditId,
          discountCodeId: discount.id,
          rmDiscountCodeId: null,
        }
        if (order.wineClubDiscountCodeId) {
          model.rmDiscountCodeId = order.wineClubDiscountCodeId
        }
        const response = await orderEditService.validateDiscountCode(model)
        onIsValidating(false)
        if (response && response.status === 'success') {
          const {discountRule} = discount
          onDiscount({...discountRule, ...discount})
        } else {
          onError('Does not fulfill the discount requirements')
        }
      }
    } catch (err) {
      onIsValidating(false)
      console.error(err)
    }
  }

  const discountValue = useMemo(() => {
    if (discount && discount.id) {
      if (discount.valueType === discountValueType.PERCENTAGE) {
        return `- ${discount.discountValue}%`
      }

      if (discount.valueType === discountValueType.FIXED_AMOUNT) {
        return `- ${simpleCurrency(discount.discountValue)}`
      }
    }
    return `--`
  }, [discount])

  return (
    <div className='input-group w-100 '>
      <div className='d-flex form-control position-relative ms-4 mt-1 h-100'>
        <select
          name='promoCode'
          className='form-select  '
          onChange={handlePromoCodeChange}
          value={discount.promoCode}
          disabled={!isPromoCode}
        >
          <option value='' selected hidden>
            Select Promo Code
          </option>
          {discounts.map((discount: any) => {
            return <option value={discount.id}>{discount.code}</option>
          })}
        </select>
      </div>

      <div className='input-group-append min-w-100px min-h-100 d-flex align-item-center m-0'>
        <div
          className={clsx(
            'position-absolute top-50  translate-middle-y translate-middle-x lh-0 text-white ',
            discount && discount.id && discount.valueType ? 'ps-2 fs-3 fw-bolder' : 'ps-9 fs-2qx'
          )}
        >
          {discountValue}
        </div>
        <KTSVG
          className='svg-icon-primary-active svg-icon-5tx input-group-text p-0 m-0 border-0'
          path='/media/icons/corksy/discount-badge.svg'
          svgClassName=''
        />
      </div>
    </div>
  )
}

export default PromoCodeSelection
